import type { WorkspaceObjectType } from '@/enums';
import { FilesTableContext, FilesTableDataContext, FilesTableLoadingContext, SelectedObjectsContainer } from '@/screens/Workspace.FilesTable';
import type { WorkspaceObject, WorkspaceObjectCapabilities, WorkspaceObjectItem } from '@/types';
import { CanUploadFilesContext, UploadFilesContext } from '@trinity/chat-components/containers/WorkspaceFileUpload/Context.js';
import { useInitiateFilesReview } from '@trinity/chat-components/containers/WorkspaceFileUpload/hooks/index.js';
import { WorkspaceBreadcrumbsContext } from '../WorkspaceObject';
import { FileUploadReviewContainer } from '../WorkspaceFileUpload/Upload.Review';

type Props = {
  data: WorkspaceObjectItem[];
  isLoading: boolean;
  breadcrumbs: WorkspaceObject[];
  parentObject: Pick<WorkspaceObject, 'id' | 'workspaceId' | 'typeId'>;
  projectId?: number;
  capabilities: WorkspaceObjectCapabilities<WorkspaceObjectType.Folder | WorkspaceObjectType.ProjectParent | WorkspaceObjectType.Brand | WorkspaceObjectType.Workspace>;
} & ChildrenProps;

export const FilesTableContainer = (props: Props) => {

  useInitiateFilesReview({
    parentObjectId: props.parentObject.id,
    workspaceId: props.parentObject.workspaceId,
  });
  return (
    <SelectedObjectsContainer>
      <FilesTableDataContext.Provider value={props.data}>
        <FilesTableLoadingContext.Provider value={props.isLoading}>
          <WorkspaceBreadcrumbsContext.Provider value={props.breadcrumbs}>
            <FilesTableContext.Provider value={{ parentObject: props.parentObject, projectId: props.projectId }}>
              <FileUploadReviewContainer>
                <UploadContainer {...props}>
                  {props.children}
                </UploadContainer>
              </FileUploadReviewContainer>
            </FilesTableContext.Provider>
          </WorkspaceBreadcrumbsContext.Provider>
        </FilesTableLoadingContext.Provider>
      </FilesTableDataContext.Provider>
    </SelectedObjectsContainer>
  );
};

const UploadContainer = (props: Props) => {
  const uploadFiles = useInitiateFilesReview({
    parentObjectId: props.parentObject.id,
    workspaceId: props.parentObject.workspaceId,
  });

  return (
    <UploadFilesContext.Provider value={uploadFiles}>
      <CanUploadFilesContext.Provider value={props.capabilities?.canAddChildren}>
        {props.children}
      </CanUploadFilesContext.Provider>
    </UploadFilesContext.Provider>
  );
};